import { ServiceDetailModel } from "./service-detail-model";


export class ServiceMasterModel {
  serviceHeaderId?: number;
  serviceName: string;
  serviceDescription?: string;
  serviceDefaultSms: number;
  isActive: 'YES' | 'NO';
  serviceDetails: ServiceDetailModel[];

   constructor(init?: Partial<ServiceMasterModel>) {
    Object.assign(this, init);
  }
}